import { render } from "./TheSwitchInTable.vue?vue&type=template&id=06e207d1"
import script from "./TheSwitchInTable.vue?vue&type=script&lang=js"
export * from "./TheSwitchInTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__